module.exports = __webpack_public_path__ + "static/media/info3.586e7cab.png";